import module from 'backoffice/herramientas/module.js'
import template from './template.html'

export class BackofficeHerramientasComponent {
}

module.component('backofficeHerramientas', {
  controller: BackofficeHerramientasComponent,
  template: template,
  bindings: {},
})



// WEBPACK FOOTER //
// ./src/herramientas/components/components.js